import { render } from "./VueloThorondorView.vue?vue&type=template&id=5ed5bfe8"
import script from "./VueloThorondorView.vue?vue&type=script&lang=js"
export * from "./VueloThorondorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__